var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('card-component',{attrs:{"block":false,"title":"Lista de e-commerces","subtitle":"","col":{xs: 12},"buttonNew":[]}},[_c('ecommerce-list-component')],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e117ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ecommerces/EcommerceList.vue
// module id = null
// module chunks = 